import { ADD_PROGRAM } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_PROGRAM.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_PROGRAM.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_PROGRAM.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
